export const DEFAULT_GUTTER_PX = 8;

/** Figma's `popover/container/body/w`. */
export const DEFAULT_WIDTH_PX = 320;

/** Figma's `popover/container/body/p`, in spacing steps. */
export const DEFAULT_PADDING = 1.5;

/** Figma's `Popover` description: the paper hugs its content up to this height, then the body scrolls. */
export const MAX_HEIGHT_PX = 420;

/** `Popover`'s own `marginThreshold`, restated for the `Popper` path so both clamp alike. */
export const VIEWPORT_PADDING_PX = 16;

/** Figma's `popover/container/stroke`. */
export const PAPER_BORDER_WIDTH_PX = 1;

/**
 * Figma's Quick tip arrow (`22298:4735`), which every popover with an arrow draws: a 16 × 8 triangle with a
 * rounded tip, `popover-arrow.svg`.
 */
export const ARROW_WIDTH_PX = 16;

/** How far the arrow's tip reaches past the paper's outer edge. */
export const ARROW_PROTRUSION_PX = 8;

/**
 * The asset's base strip, the 1px under the triangle that lands on the paper's border: the arrow paints
 * over the border where the two meet, and its own two outer sides carry the outline on.
 */
export const ARROW_OVERLAP_PX = 1;

/**
 * From the paper's corner to the arrow's near side on a `-start` / `-end` placement. Figma gives the arrow
 * a 40px slot flush with the corner and draws the triangle at its far end.
 */
export const ARROW_EDGE_INSET_PX = 24;

/** Where the tip lands on a `-start` / `-end` placement, from the corner it is aligned to. */
export const ARROW_TIP_FROM_CORNER_PX = ARROW_EDGE_INSET_PX + ARROW_WIDTH_PX / 2;

/** The roles MUI gives the overlays it portals out of a panel: `Autocomplete`/`Select`, `Menu`, `Dialog`. */
export const PORTALED_OVERLAY_SELECTOR =
  '[role="listbox"], [role="menu"], [role="dialog"], [role="grid"]';
